import React from 'react'
import { DefaultLayout } from '../layouts'

export const SurveyScreen = () => {
  return (
    <DefaultLayout>
      <h1>Example Amplitude embed</h1>
      <iframe
        title='Amplitude'
        className='airtable-embed mote-brand'
        src='https://analytics.amplitude.com/share/654634ffee064c02a7ef2089f5d2ee5e'
        frameborder='0'
        onmousewheel=''
        width='100%'
        height='1000'
        styleName='background: transparent; border: 1px solid #ccc;'
      />
    </DefaultLayout>
  )
}
